import PropTypes from 'prop-types';

export const pageLoadFailureTranslationKeys = {
    pageLoadFailureTitle: PropTypes.string.isRequired,
    pageLoadFailureDescription: PropTypes.string.isRequired,
    commonRetry: PropTypes.string.isRequired,
};

export const pageLoadFailureTranslationsShape = PropTypes.shape(pageLoadFailureTranslationKeys);
